import { DIACRITICS_VALUES } from '@shared/directives/constants/diacritics.constants';

export function replaceDiacritics(s: string): string {
  let value = s;
  const diacritics = DIACRITICS_VALUES;
  for (let i = 0; i < diacritics.length; i++) {
    value = value.replace(diacritics[i].letters, diacritics[i].base);
  }
  return value;
}
